var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Link } from "syf-component-library/ui/atoms";
export var StatementsTableFooter = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n"])));
export var PolicyLink = styled(Link)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0;\n"], ["\n  padding: 0;\n"])));
var templateObject_1, templateObject_2;
